<template>
  <div
    class="animated fadeIn disable-text-select"
    @keyup.enter="onFilter"
    style="overflow: auto;  padding-bottom: 6rem; padding-left: 4px; padding-right: 4px;"
  >
    <div class="form-group row">
      <div class="w-100">
        <label
          style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="
            showFilterGeral === true
              ? (showFilterGeral = false)
              : (showFilterGeral = true)
          "
        >
          <i v-if="showFilterGeral" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>Geral
        </label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div> -->
      </div>
    </div>
    <div v-if="showFilterGeral">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Campanha:</label>
          <div class="input-group">
            <v-select
              v-model="form.campanha.value"
              :options="form.campanha.listOptions"
              :reduce="option => option.text"
              placeholder="Selecione a campanha"
              class="w-100"
              label="text"
            >
              <template v-slot:no-options
              >Nenhuma campanha encontrada.
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Nome:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Nome'"
              v-model="form.nome.value"
              :state="form.nome.state"
              autofocus
            />
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> CPF/CNPJ:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o CPF ou CNPJ'"
              v-model="form.documento.value"
              :state="form.documento.state"
              autofocus
            />
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="w-100 pt-2">
          <button
            type="button"
            class="btn rounded-4 btn-third w-100"
            v-on:click="onFilter"
          >
            Filtrar
          </button>
        </div>
        <div class="w-100 pt-2">
          <button
            type="button"
            class="btn rounded-4 btn-default w-100"
            v-on:click="onClearFilters"
          >
            Limpar Filtros
          </button>
        </div>
      </div>
      <!-- <div class="form-group row" style="margin-top: 600px;">&nbsp;</div> -->
    </div>
  </div>
</template>

<script>
import Roles from '@/shared/utils/roles.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import { loading } from '@/shared/utils/UIHelper'
import FormSearch from './search-form.js'

import CampaignRepository from '@/shared/http/repositories/campaign/campaign.js'

import { JWTService } from '@/shared/services/jwt'

const DataSearch = {
  campanha: null,
  nome: null,
  documento: null
}

export default {
  name: 'ReportCardSearch',
  mixins: [ActionsForm],
  data () {
    return {
      data: DataSearch,
      form: FormSearch,
      roles: Roles,
      permissions: null,
      selected: 'gerente',
      showFilterGeral: true
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  created () {
    this.onClear()
    this.permissions = JWTService.GetRoles()
    this.onLoadAllCampanha()
  },
  methods: {
    onLoad () {
      this.onClearFilters()
      this.onCloseFilterAccordion()
    },
    onClearFilters () {
      Tools.ClearDataForms(this.form, this.data)
    },
    onCloseFilterAccordion () {
      this.showFilterGeral = true
    },
    onFilter () {
      Tools.SetValueToSave(this.form, this.data)
      this.$eventHub.emit('Filter', { filters: this.data })
    },
    validateFilters () {
      this.data.campanha = this.data.campanha ? this.data.campanha : null
      this.data.nome = this.data.nome ? this.data.nome : null
      this.data.documento = this.data.documento ? this.data.documento : null
    },
    mapSelectedValues (item) {
      if (!item) {
        return undefined
      }

      if (item.selected && item.selected.length > 0) {
        return item.selected.map(i => i.value)
      }

      if (item.value) {
        return item.value.value
      }

      return undefined
    },
    onLoadAllCampanha () {
      loading.push()
      CampaignRepository.GetAll()
        .then(res => {
          if (res.status === 200 && res.data) {
            this.form.campanha.listOptions = res.data.content.map(x => ({'value': x.id, 'text': x.nome}))
            loading.pop()
          }
        })
        .catch(this.onException)
    }
  }
}
</script>

<style lang="scss" scoped>
.disable-text-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.animated.fadeIn {
  padding-bottom: 2rem;
}

.animated.fadeIn::-webkit-scrollbar {
  display: none;
}

.form-group {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/reports/campanha/envioCampanha/search/search.vue